module.exports = __webpack_public_path__ + "static/media/inner-harbor.58453c19.jpg";